import polygonDifference from '@turf/difference';
import { MultiPolygon, Polygon, Feature } from '@turf/turf';

export const isInnerPolygon = (
    innerPolygon: Feature<Polygon | MultiPolygon>,
    outerPolygon: Feature<Polygon | MultiPolygon>,
) => {
    return polygonDifference(innerPolygon, outerPolygon) === null;
};
